import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand
} from "@aws-sdk/client-cognito-identity-provider";
import { ImpersonationData } from "./types";
import { UserLite } from "../../users/api/types";
import { UserAuthSession } from "../types";


export const cognitoIdentityProviderClient = new CognitoIdentityProviderClient({
  region: "eu-west-2"
});


export async function getImpersonationData(
  user: UserLite,
  session: UserAuthSession | undefined
): Promise<ImpersonationData | undefined> {

  const targetUserId = user.id ?? "";
  const clientId = window.authConfig?.partnerPortalClientId;
  const jwtToken = session?.accessToken ?? "";

  try {
    const initiateAuthCommand = new InitiateAuthCommand({
      AuthFlow: "CUSTOM_AUTH",
      ClientId: clientId,
      AuthParameters: { USERNAME: targetUserId }
    });

    const { Session } = await cognitoIdentityProviderClient.send(initiateAuthCommand);
    if (!Session) {
      throw new Error("Failed to initiate impersonation session.");
    }

    const respondToAuthChallengeCommand = new RespondToAuthChallengeCommand({
      ClientId: clientId,
      ChallengeName: "CUSTOM_CHALLENGE",
      ChallengeResponses: { USERNAME: targetUserId, ANSWER: jwtToken },
      ClientMetadata: {
        type: "IMPERSONATION",
        impersonatorEmail: session?.userProfile?.email ?? "",
        impersonatorUserId: session?.userProfile?.username ?? "",
        impersonatorGivenName: session?.userProfile?.firstName ?? "",
        impersonatorFamilyName: session?.userProfile?.lastName ?? ""
      },
      Session: Session
    });

    const { AuthenticationResult } = await cognitoIdentityProviderClient.send(respondToAuthChallengeCommand);

    if (!AuthenticationResult || !AuthenticationResult.IdToken) {
      throw new Error("Failed to obtain authentication result.");
    }
    return {
      hub_url: window.authConfig.customerPortalUrl,
      redirect_uri: window.authConfig.customerPortalUrl,
      jwt: AuthenticationResult.IdToken,
      access_token: AuthenticationResult.AccessToken,
      client_id: clientId,
      response_type: "code"
    };
  } catch (error: any) {
    throw new Error(error.message || error);
  }
}
